module.exports = __webpack_public_path__ + "img/NDZ_Spotify.c1d3fc3e.svg";